import React from 'react';
import { CreateDishState } from './createDishState/CreateDishState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const CreateDishPageV2: React.FC = () => {
	return (
		<CreateDishState>
			<Forms />
			<ModalWindows />
		</CreateDishState>
	);
};
